export default __webpack_public_path__ + "static/media/image.98e3aaa4.svg";